import { Spinner } from "@vwfs-bronson/bronson-react";
// import { useMatchMakerWizard } from "../../hooks/useMatchMakerWizard";

export const Loading = () => {
    return <Spinner fullPage />;
    // const { isLoading } = useMatchMakerWizard();

    // return <>{isLoading && <Spinner fullPage />}</>;
};

export default Loading;
